export default {
    actions: {
        save: 'Salvar',
        simulate: 'Simular',
    },

    errors: {
        between: 'O valor do campo {label} deve ser entre {min} e {max}.',
        maxLength: 'O campo {label} deve ter no máximo {length} caracteres.',
        minLength: 'O campo {label} deve ter no mínimo {length} caracteres.',
        minValue: 'O valor do campo {label} deve ser maior ou igual a {min}.',
        required: 'O campo {label} é obrigatório.',
        requiredIf: 'O campo {label} é obrigatório no contexto atual.',
    },

    title: '{prefix} {resource}',

    titlePrefix: {
        add: 'Adicionar',
        edit: 'Editar',
    },

    messages: {
        saved: 'O {resource} {name} foi salvo com sucesso.',
    },

    settings: {
        labels: {
            slug: 'Slug',
            name: 'Nome',
            value: 'Valor',
        },
    },

    // todo move to resources.js
    customer: {
        hints: {
            ignore:
                'O cliente será ignorado ao calcular faturas, commissões e indicadores.',
        },

        labels: {
            name: 'Nome',
            'trade-name': 'Nome Fantasia',
            'legal-name': 'Razão Social',
            cpf: 'CPF',
            cnpj: 'CNPJ',
            'legal-person': 'Pessoa Jurídica',
            'normal-person': 'Pessoa Física',
            email: 'Email',
            phone: 'Telefone',
            status: 'Status',
            ignore: 'Ignorar',
        },

        statuses: {
            all: 'Todos',
            active: 'Ativo',
            actives: 'Ativos',
            'bad-debit': 'Inadimplentes',
            blocked: 'Bloqueado',
            blockeds: 'Bloqueados',
            trial: 'Trial',
            trials: 'Trials',
            deleted: 'Excluído',
            deleteds: 'Excluídos',
            canceled: 'Cancelado',
            canceleds: 'Cancelados',
        },
    },
}
